import { useParams } from 'react-router-dom';
import { PermissionGuard } from '@/features/auth';
import { Alert, DetailPageHeader, PageContainer } from '@shared/components';
import { FundAccountStatementView } from '../components/FundAccountStatement/FundAccountStatementView';
import { useFundAccountStatementPage } from '../hooks/useFundAccountStatementPage';
import { isUuid } from '../utils/isUuid';
import { INVALID_FUND_ACCOUNT_LINK_MESSAGE, NOT_ENTITLED_MESSAGE } from '../utils/fundStatementLabels';

interface Ids {
    dealerId: string;
    sellingDealerId: string;
    productId: string;
}

function FundAccountStatementContent({ dealerId, sellingDealerId, productId }: Ids) {
    const model = useFundAccountStatementPage(dealerId, sellingDealerId, productId);
    return (
        <>
            <DetailPageHeader breadcrumbs={model.breadcrumbs} title={model.title} subtitle={model.subtitle} />
            <PageContainer>
                <FundAccountStatementView {...model} />
            </PageContainer>
        </>
    );
}

export function FundAccountStatementPage() {
    const { id = '', sellingDealerId = '', productId = '' } = useParams();
    if (![id, sellingDealerId, productId].every(isUuid)) {
        return (
            <PageContainer>
                <Alert variant="error" role="alert">{INVALID_FUND_ACCOUNT_LINK_MESSAGE}</Alert>
            </PageContainer>
        );
    }
    return (
        <PermissionGuard
            permission={{ resource: 'ledger', action: 'fund-statement.read' }}
            showFallback
            fallback={
                <PageContainer>
                    <Alert variant="info" role="note">{NOT_ENTITLED_MESSAGE}</Alert>
                </PageContainer>
            }
        >
            <FundAccountStatementContent dealerId={id} sellingDealerId={sellingDealerId} productId={productId} />
        </PermissionGuard>
    );
}
